import { FC, useContext } from 'react';

import { Button, H1, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { IModalDeleteProps } from './interfaces';
import s from './ModalDelete.module.scss';

export const ModalDelete: FC<IModalDeleteProps> = ({
  onClose,
  title,
  description,
  loading,
  action,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <Modal className={s.modal} onClose={onClose}>
      <div className={s.top}>
        <H1>{title}</H1>
        <span className={s.text}>{description}</span>
      </div>

      <div className={s.buttons_block}>
        <Button variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          isLoading={loading}
          variant="primary"
          color="red"
          onClick={action}
        >
          {t('delete')}
        </Button>
      </div>
    </Modal>
  );
};
